<template>
  <div class="contai_h">
    <!-- 这是头部信息 -->
    <div class="contai">
      <i class="el-icon-s-home">
        <router-link to="/">首页</router-link>
        <span class="head_text">>待评估订单 </span>
      </i>
      <div class="haed_cont">
        <span>今天是：{{ deta }}</span>
      </div>

      <div class="head_right">
        <span>待评估订单：{{ len }}</span>
      </div>
    </div>

    <!-- 数据详细列表 -->
    <div class="contai_li">
      <el-table :data="this.items" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="提交评估日期：">
                <span>{{ props.row.deta }}</span>
              </el-form-item>
              <el-form-item label="联系电话"
                >:
                <span>{{ props.row.number }}</span>
              </el-form-item>
              <el-form-item label="典当种类"
                >:
                <span>{{ props.row.itemlb }}</span>
              </el-form-item>
              <el-form-item :label="props.row.nf"
                >:
                <span>{{ props.row.attrsx }}</span>
              </el-form-item>
              <el-form-item :label="props.row.zl"
                >:
                <span>{{ props.row.typezl }}</span>
              </el-form-item>
              <el-form-item :label="props.row.weight"
                >:
                <span>{{ props.row.itemattsx }}</span>
              </el-form-item>
              <el-form-item label="鉴定方式"
                >:
                <span>{{ props.row.mode }}</span>
              </el-form-item>

              <el-form-item label="当品描述"
                >:
                <span>{{ props.row.descrms }}</span>
              </el-form-item>
            </el-form>

            <div class="con_img">
              <span>当品图片：</span>
            </div>
            <!-- 当品图片 -->
            <div class="img">
              <img :src="props.row.images" alt="" />
              <img
                :src="props.row.imags"
                alt=""
                v-if="
                  props.row.imags !==
                  'https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/tj.png'
                "
              />
              <img
                :src="props.row.imas"
                alt=""
                v-if="
                  props.row.imas !==
                  'https://6368-changan2020-qtz0s-1302496284.tcb.qcloud.la/images/tj.png'
                "
              />
            </div>
            <!-- 评估操作 -->
            <div class="con">
              <span>评估操作：</span>
              <el-button type="primary" @click="cliSho(props.row._id)">操作</el-button>
              <!-- 操作栏的价格相关操作 -->
              <div class="con_cz" v-show="czl">
                <!-- 修改填写预估价格 -->
                <div class="con_czin">
                  <h3>预估价格：</h3>
                  <el-input
                    v-model="pri"
                    placeholder="请输入预估价格"
                    class="inpo"
                    @input="input_text"
                  ></el-input>
                  元
                  <el-button type="success" class="but_o" @click="btn_tj">提交</el-button>
                </div>
                <!-- 填写修改评估价格 -->
                <div class="con_czin">
                  <h3>评估价格：</h3>
                  <el-input
                    v-model="price"
                    placeholder="请输入评估价格"
                    class="inpo"
                    @input="input_te"
                  ></el-input>
                  元
                  <el-button type="success" class="but_o" @click="btn_xg">提交</el-button>
                </div>

                <!-- 删除该订单 -->
                <div class="deite">
                  <h3>删除这个订单：</h3>
                  <el-button type="success" @click="detai">删除订单</el-button>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="提交日期" prop="deta"> </el-table-column>
        <el-table-column label="当品类型" prop="itemlb"> </el-table-column>
        <el-table-column label="种类" prop="typezl"></el-table-column>
        <el-table-column label="鉴定方式" prop="mode"></el-table-column>
        <el-table-column label="典当物品" prop="itemlb"> </el-table-column>
        <el-table-column label="当物属性" prop="itemattsx"> </el-table-column>
        <el-table-column label="电话" prop="number"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "Assessment",
  data() {
    return {
      deta: 0, //今日
      len: 0,
      ACCESS_TOKEN: "",
      items: [],
      input: "",
      czl: false,
      id: "", //存储物品的id
      pri: "", //预估价格
      price: "", //评估价格
      inpu: "", //存储修改的预估价格的值
      inpus: "", //存储修改的评估价的值
    };
  },
  methods: {
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("date");
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },

    cliSho(e) {
      this.id = e;
      this.czl = !this.czl;
      this.clik();
    },

    // 请求被点击的要操作的数据
    clik() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: 'db.collection("js2020").doc("' + this.id + '").get()',
        })
        .then((cc) => {
          cc.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.pri = cc.data.data[0].pri;
          this.price = cc.data.data[0].price;
        });
    },

    // 提交预估修改的值
    btn_tj() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("js2020").doc("' +
            this.id +
            '").update({data:{pri:' +
            this.inpu +
            "}})",
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "预估价格修改成功",
            type: "success",
            center: true,
          });
        })
        .catch(() => {
          this.$message.error("请刷新页面后重试...");
        });
    },
    //提交修改的评估价
    btn_xg() {
      this.axios
        .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query:
            'db.collection("js2020").doc("' +
            this.id +
            '").update({data:{price:' +
            this.inpus +
            "}})",
        })
        .then(() => {
          this.$message({
            showClose: true,
            message: "评估价格修改成功",
            type: "success",
            center: true,
          });
        })
        .catch(() => {
          this.$message.error("请刷新页面后重试...");
        });
    },
    //拿到修改预估价格输入框里的值
    input_text(e) {
      this.inpu = e;
    },
    input_te(e) {
      this.inpus = e;
    },

    //删除订单
    detai() {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
              env: `${this.userData.env}`,
              query: 'db.collection("js2020").doc("' + this.id + '").remove()',
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  created(){
     //获取到this.ACCESS_TOKEN
     this.getTokens()

    //获取当前登录的用户数据
    this.getUserToken()
  },
  mounted() {
    this.deta = dayjs().format("YYYY-MM-DD ddd");
    // this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN");

    setTimeout(()=>{
        // 请求所有的待评估的数据
    this.axios
      .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
        env: `${this.userData.env}`,
        query: 'db.collection("js2020").where({price:""}).limit(1000).get()',
      })
      .then((aa) => {
        if (aa.data.errcode === 0) {
          aa.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.items = aa.data.data;
          this.len = aa.data.data.length;
        } else {
            this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
        }
      });
    },800)
  
  },
};
</script>
<style scoped>
.contai_h {
  margin: 0 0;
}
.contai {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}
.contai i {
  font-size: 25px;
  margin: 13px 40px;
}
.head_text {
  font-size: 20px;
  margin: 2px 6px;
}
.router-link-active {
  text-decoration: none;
  font-size: 20px;
  margin-left: 10px;
}
.haed_cont {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 auto;
  font-size: 20px;
}
.head_right {
  margin: 13px 50px;
  font-size: 20px;
}
.contai_li {
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  margin-top: 10px;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.cont_in {
  display: flex;
  flex-direction: row;
}
.cont_i {
  display: flex;
  flex-direction: column;
}
.img {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.con_img {
  margin: 20px 0;
}
.img img {
  width: 300px;
  height: 300px;
}
.con_czin {
  margin: 40px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.inpo {
  width: 15%;
}
.but_o {
  margin: 0 50px;
}
</style>
